// import React, { useState, useEffect, forwardRef } from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const TextEditor = forwardRef(({ content, onChange }, ref) => {
//     const [editorContent, setEditorContent] = useState(content || "");

//     useEffect(() => {
//         setEditorContent(content || "");
//     }, [content]);

//     const handleChange = (value) => {
//         setEditorContent(value);
//         onChange(value);
//     };

//     return <ReactQuill ref={ref} value={editorContent} onChange={handleChange} />;
// });

// export default TextEditor;

// TextEditor.js


import React from 'react'
import { Editor } from '@tinymce/tinymce-react';

const ContentEditor = ({ content, onChange }) => {
    return (
        <Editor
            apiKey='q3uopmdqztrtvg9h1b59ig4corwk210168m2lkw32bq6xkoq'
            value={content} // controlled value
            onEditorChange={onChange}
            init={{
                plugins: [
                    // Core editing features
                    'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount',
                    // Your account includes a free trial of TinyMCE premium features
                    // Try the most popular premium features until Oct 10, 2025:
                    'checklist', 'mediaembed', 'casechange', 'formatpainter', 'pageembed', 'a11ychecker', 'tinymcespellchecker', 'permanentpen', 'powerpaste', 'advtable', 'advcode', 'advtemplate', 'ai', 'uploadcare', 'mentions', 'tinycomments', 'tableofcontents', 'footnotes', 'mergetags', 'autocorrect', 'typography', 'inlinecss', 'markdown', 'importword', 'exportword', 'exportpdf'
                ],
                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography uploadcare | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                tinycomments_mode: 'embedded',
                tinycomments_author: 'Author name',
                mergetags_list: [
                    { value: 'First.Name', title: 'First Name' },
                    { value: 'Email', title: 'Email' },
                ],
                ai_request: (request, respondWith) => respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
                uploadcare_public_key: 'c26cbd3aae1e2c217d49',
                branding: false
            }}
        // initialValue="Welcome to TinyMCE!"
        />
    )
}

export default ContentEditor
